// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from "react";
import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
  forwardRef,
  useStyleConfig,
} from "@chakra-ui/react";

export type IconButtonProps = ChakraIconButtonProps;

export const IconButton = forwardRef<IconButtonProps, "button">(
  ({ variant, sx, ...rest }, ref) => {
    const styles = useStyleConfig("IconButton", { variant });
    return (
      <ChakraIconButton isRound sx={{ ...styles, ...sx }} {...rest} ref={ref} />
    );
  }
);
